module.exports = __webpack_public_path__ + "img/bobsled1.16e262ff.jpg";